/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyExternalAIAssistantScope,
  PharmacyExternalAIAssistantScopeFromJSON,
  PharmacyExternalAIAssistantScopeFromJSONTyped,
  PharmacyExternalAIAssistantScopeToJSON,
  PharmacyMeritTags,
  PharmacyMeritTagsFromJSON,
  PharmacyMeritTagsFromJSONTyped,
  PharmacyMeritTagsToJSON,
  PharmacyMobileOrderCallingScreenMessage,
  PharmacyMobileOrderCallingScreenMessageFromJSON,
  PharmacyMobileOrderCallingScreenMessageFromJSONTyped,
  PharmacyMobileOrderCallingScreenMessageToJSON,
  PharmacyPaymentMethod,
  PharmacyPaymentMethodFromJSON,
  PharmacyPaymentMethodFromJSONTyped,
  PharmacyPaymentMethodToJSON,
  PharmacyPharmacyDeliverySettings,
  PharmacyPharmacyDeliverySettingsFromJSON,
  PharmacyPharmacyDeliverySettingsFromJSONTyped,
  PharmacyPharmacyDeliverySettingsToJSON,
  PharmacyPharmacyHours,
  PharmacyPharmacyHoursFromJSON,
  PharmacyPharmacyHoursFromJSONTyped,
  PharmacyPharmacyHoursToJSON,
  PharmacyPharmacyStations,
  PharmacyPharmacyStationsFromJSON,
  PharmacyPharmacyStationsFromJSONTyped,
  PharmacyPharmacyStationsToJSON,
  PharmacyRecurringCalendar,
  PharmacyRecurringCalendarFromJSON,
  PharmacyRecurringCalendarFromJSONTyped,
  PharmacyRecurringCalendarToJSON,
  PharmacyTokushoho,
  PharmacyTokushohoFromJSON,
  PharmacyTokushohoFromJSONTyped,
  PharmacyTokushohoToJSON,
} from "./";

export const PharmacyPharmacyRegistrableTypename = "PharmacyPharmacyRegistrable" as const;

/**
 *
 * @export
 * @interface PharmacyPharmacyRegistrable
 */
export interface PharmacyPharmacyRegistrable {
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  address: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  aiOcrRecognitionMode?: PharmacyPharmacyRegistrableAiOcrRecognitionModeEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  calendarType: PharmacyPharmacyRegistrableCalendarTypeEnum;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacyRegistrable
   */
  chainId?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof PharmacyPharmacyRegistrable
   */
  closedDays: Array<string>;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacyRegistrable
   */
  counselingBoothCount?: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  counselingBoothName?: string;
  /**
   *
   * @type {PharmacyPharmacyHours}
   * @memberof PharmacyPharmacyRegistrable
   */
  counselingReceptionHours?: PharmacyPharmacyHours;
  /**
   *
   * @type {Array<PharmacyRecurringCalendar>}
   * @memberof PharmacyPharmacyRegistrable
   */
  counselingRecurringCalendars?: Array<PharmacyRecurringCalendar>;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacyRegistrable
   */
  counselingSlotMinutes?: number;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  createTalkroom?: boolean;
  /**
   *
   * @type {PharmacyPharmacyDeliverySettings}
   * @memberof PharmacyPharmacyRegistrable
   */
  deliverySetting?: PharmacyPharmacyDeliverySettings;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  disableCounselingSlotUnspecified?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof PharmacyPharmacyRegistrable
   */
  dispensingCounters?: Array<string>;
  /**
   *
   * @type {PharmacyPharmacyHours}
   * @memberof PharmacyPharmacyRegistrable
   */
  dispensingReceptionHours?: PharmacyPharmacyHours;
  /**
   *
   * @type {Array<PharmacyRecurringCalendar>}
   * @memberof PharmacyPharmacyRegistrable
   */
  dispensingRecurringCalendars?: Array<PharmacyRecurringCalendar>;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  email: string;
  /**
   *
   * @type {Array<PharmacyExternalAIAssistantScope>}
   * @memberof PharmacyPharmacyRegistrable
   */
  externalAiAssistantScope?: Array<PharmacyExternalAIAssistantScope>;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  externalId?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  fax: string;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  faxPrescriptionWithImage?: boolean;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacyRegistrable
   */
  groupId?: number;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  hasLineOfficialAccount?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  ignorePublicHoliday?: boolean;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  institutionCode: string;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  isCounselingReceptionUntilClosing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  isDispensing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  isDisplayVisitWithinOneHour?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  isMobileOrderQrCodeEnlarged?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  isOnline?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  isOnlinePayment?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  isParking?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  isPrescription?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  isSameDayDelivery?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  isScreening?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  isTell?: boolean;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacyRegistrable
   */
  latitude: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  lineInterviewUrl?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacyRegistrable
   */
  longitude: number;
  /**
   *
   * @type {PharmacyMeritTags}
   * @memberof PharmacyPharmacyRegistrable
   */
  meritTag?: PharmacyMeritTags;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacyRegistrable
   */
  minIntegratedCounselingIntervalMinutes?: number;
  /**
   *
   * @type {Array<PharmacyMobileOrderCallingScreenMessage>}
   * @memberof PharmacyPharmacyRegistrable
   */
  mobileOrderCallingScreenMessages?: Array<PharmacyMobileOrderCallingScreenMessage>;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  mynaHomeWebUrl?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  name: string;
  /**
   *
   * @type {PharmacyPharmacyStations}
   * @memberof PharmacyPharmacyRegistrable
   */
  nearestStation: PharmacyPharmacyStations;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  note: string;
  /**
   *
   * @type {PharmacyPaymentMethod}
   * @memberof PharmacyPharmacyRegistrable
   */
  onlinePaymentMethod?: PharmacyPaymentMethod;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  ownInterviewUrl?: string;
  /**
   *
   * @type {PharmacyPaymentMethod}
   * @memberof PharmacyPharmacyRegistrable
   */
  paymentMethod?: PharmacyPaymentMethod;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  postalCode: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  prescriptionReadingMode?: PharmacyPharmacyRegistrablePrescriptionReadingModeEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  printerIp?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  printerPaperType?: PharmacyPharmacyRegistrablePrinterPaperTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  printerType: PharmacyPharmacyRegistrablePrinterTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  recommendation?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  secondExternalId?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  sendFollowUpMessage?: PharmacyPharmacyRegistrableSendFollowUpMessageEnum;
  /**
   *
   * @type {number}
   * @memberof PharmacyPharmacyRegistrable
   */
  talkroomExpireDays: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  tel: string;
  /**
   *
   * @type {PharmacyTokushoho}
   * @memberof PharmacyPharmacyRegistrable
   */
  tokushoho?: PharmacyTokushoho;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableAcceptCode?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableAiocr?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableCounselingBoothVoiceAnnouncement?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableCounselingSlotQuota?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableCrowdStatus?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableDigitalPrescription?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableDispensingFeature?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableDispensingType?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableExternalAiAssistant?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableMynaHomeWeb?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableOcrPrescription?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableOnlineCounselingAutoAccepted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableOnlineMedicationGuidance?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usablePrescriptionInquiry?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableScanPrescription?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableSkipUnluckyNumbers?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableTouchReception?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  usableVoiceAnnouncement?: boolean;
  /**
   *
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  visibility: PharmacyPharmacyRegistrableVisibilityEnum;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  wantsEmailNotification?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  wantsFaxCounselingRequestedRemind?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyPharmacyRegistrable
   */
  wantsFaxNotification?: boolean;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyPharmacyRegistrable
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyRegistrableAiOcrRecognitionModeEnum {
  Quality = "quality",
  Speed = "speed",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyRegistrableCalendarTypeEnum {
  Gregorian = "gregorian",
  Japanese = "japanese",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyRegistrablePrescriptionReadingModeEnum {
  QrOnly = "qr_only",
  AiOcrOnly = "ai_ocr_only",
  QrOcr = "qr_ocr",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyRegistrablePrinterPaperTypeEnum {
  Roll58 = "roll58",
  Roll80 = "roll80",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyRegistrablePrinterTypeEnum {
  Default = "default",
  StarM = "star_m",
  StarMLan = "star_m_lan",
  CitizenLan = "citizen_lan",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyRegistrableSendFollowUpMessageEnum {
  None = "none",
  Auto = "auto",
  Manual = "manual",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyPharmacyRegistrableVisibilityEnum {
  Public = "public",
  Private = "private",
  Limited = "limited",
}

export function PharmacyPharmacyRegistrableFromJSON(json: any): PharmacyPharmacyRegistrable {
  return PharmacyPharmacyRegistrableFromJSONTyped(json, false);
}

export function PharmacyPharmacyRegistrableFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyPharmacyRegistrable {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyPharmacyRegistrableTypename,

    address: json["address"],
    aiOcrRecognitionMode: !exists(json, "ai_ocr_recognition_mode") ? undefined : json["ai_ocr_recognition_mode"],
    calendarType: json["calendar_type"],
    chainId: !exists(json, "chain_id") ? undefined : json["chain_id"],
    closedDays: json["closed_days"],
    counselingBoothCount: !exists(json, "counseling_booth_count") ? undefined : json["counseling_booth_count"],
    counselingBoothName: !exists(json, "counseling_booth_name") ? undefined : json["counseling_booth_name"],
    counselingReceptionHours: !exists(json, "counseling_reception_hours")
      ? undefined
      : PharmacyPharmacyHoursFromJSON(json["counseling_reception_hours"]),
    counselingRecurringCalendars: !exists(json, "counseling_recurring_calendars")
      ? undefined
      : (json["counseling_recurring_calendars"] as Array<any>).map(PharmacyRecurringCalendarFromJSON),
    counselingSlotMinutes: !exists(json, "counseling_slot_minutes") ? undefined : json["counseling_slot_minutes"],
    createTalkroom: !exists(json, "create_talkroom") ? undefined : json["create_talkroom"],
    deliverySetting: !exists(json, "delivery_setting")
      ? undefined
      : PharmacyPharmacyDeliverySettingsFromJSON(json["delivery_setting"]),
    disableCounselingSlotUnspecified: !exists(json, "disable_counseling_slot_unspecified")
      ? undefined
      : json["disable_counseling_slot_unspecified"],
    dispensingCounters: !exists(json, "dispensing_counters") ? undefined : json["dispensing_counters"],
    dispensingReceptionHours: !exists(json, "dispensing_reception_hours")
      ? undefined
      : PharmacyPharmacyHoursFromJSON(json["dispensing_reception_hours"]),
    dispensingRecurringCalendars: !exists(json, "dispensing_recurring_calendars")
      ? undefined
      : (json["dispensing_recurring_calendars"] as Array<any>).map(PharmacyRecurringCalendarFromJSON),
    email: json["email"],
    externalAiAssistantScope: !exists(json, "external_ai_assistant_scope")
      ? undefined
      : (json["external_ai_assistant_scope"] as Array<any>).map(PharmacyExternalAIAssistantScopeFromJSON),
    externalId: !exists(json, "external_id") ? undefined : json["external_id"],
    fax: json["fax"],
    faxPrescriptionWithImage: !exists(json, "fax_prescription_with_image")
      ? undefined
      : json["fax_prescription_with_image"],
    groupId: !exists(json, "group_id") ? undefined : json["group_id"],
    hasLineOfficialAccount: !exists(json, "has_line_official_account") ? undefined : json["has_line_official_account"],
    ignorePublicHoliday: !exists(json, "ignore_public_holiday") ? undefined : json["ignore_public_holiday"],
    institutionCode: json["institution_code"],
    isCounselingReceptionUntilClosing: !exists(json, "is_counseling_reception_until_closing")
      ? undefined
      : json["is_counseling_reception_until_closing"],
    isDispensing: !exists(json, "is_dispensing") ? undefined : json["is_dispensing"],
    isDisplayVisitWithinOneHour: !exists(json, "is_display_visit_within_one_hour")
      ? undefined
      : json["is_display_visit_within_one_hour"],
    isMobileOrderQrCodeEnlarged: !exists(json, "is_mobile_order_qr_code_enlarged")
      ? undefined
      : json["is_mobile_order_qr_code_enlarged"],
    isOnline: !exists(json, "is_online") ? undefined : json["is_online"],
    isOnlinePayment: !exists(json, "is_online_payment") ? undefined : json["is_online_payment"],
    isParking: !exists(json, "is_parking") ? undefined : json["is_parking"],
    isPrescription: !exists(json, "is_prescription") ? undefined : json["is_prescription"],
    isSameDayDelivery: !exists(json, "is_same_day_delivery") ? undefined : json["is_same_day_delivery"],
    isScreening: !exists(json, "is_screening") ? undefined : json["is_screening"],
    isTell: !exists(json, "is_tell") ? undefined : json["is_tell"],
    latitude: json["latitude"] == "" ? undefined : json["latitude"],
    lineInterviewUrl: !exists(json, "line_interview_url") ? undefined : json["line_interview_url"],
    longitude: json["longitude"] == "" ? undefined : json["longitude"],
    meritTag: !exists(json, "merit_tag") ? undefined : PharmacyMeritTagsFromJSON(json["merit_tag"]),
    minIntegratedCounselingIntervalMinutes: !exists(json, "min_integrated_counseling_interval_minutes")
      ? undefined
      : json["min_integrated_counseling_interval_minutes"],
    mobileOrderCallingScreenMessages: !exists(json, "mobile_order_calling_screen_messages")
      ? undefined
      : (json["mobile_order_calling_screen_messages"] as Array<any>).map(
          PharmacyMobileOrderCallingScreenMessageFromJSON
        ),
    mynaHomeWebUrl: !exists(json, "myna_home_web_url") ? undefined : json["myna_home_web_url"],
    name: json["name"],
    nearestStation: PharmacyPharmacyStationsFromJSON(json["nearest_station"]),
    note: json["note"],
    onlinePaymentMethod: !exists(json, "online_payment_method")
      ? undefined
      : PharmacyPaymentMethodFromJSON(json["online_payment_method"]),
    ownInterviewUrl: !exists(json, "own_interview_url") ? undefined : json["own_interview_url"],
    paymentMethod: !exists(json, "payment_method") ? undefined : PharmacyPaymentMethodFromJSON(json["payment_method"]),
    postalCode: json["postal_code"],
    prescriptionReadingMode: !exists(json, "prescription_reading_mode") ? undefined : json["prescription_reading_mode"],
    printerIp: !exists(json, "printer_ip") ? undefined : json["printer_ip"],
    printerPaperType: !exists(json, "printer_paper_type") ? undefined : json["printer_paper_type"],
    printerType: json["printer_type"],
    recommendation: !exists(json, "recommendation") ? undefined : json["recommendation"],
    secondExternalId: !exists(json, "second_external_id") ? undefined : json["second_external_id"],
    sendFollowUpMessage: !exists(json, "send_follow_up_message") ? undefined : json["send_follow_up_message"],
    talkroomExpireDays: json["talkroom_expire_days"],
    tel: json["tel"],
    tokushoho: !exists(json, "tokushoho") ? undefined : PharmacyTokushohoFromJSON(json["tokushoho"]),
    usableAcceptCode: !exists(json, "usable_accept_code") ? undefined : json["usable_accept_code"],
    usableAiocr: !exists(json, "usable_aiocr") ? undefined : json["usable_aiocr"],
    usableCounselingBoothVoiceAnnouncement: !exists(json, "usable_counseling_booth_voice_announcement")
      ? undefined
      : json["usable_counseling_booth_voice_announcement"],
    usableCounselingSlotQuota: !exists(json, "usable_counseling_slot_quota")
      ? undefined
      : json["usable_counseling_slot_quota"],
    usableCrowdStatus: !exists(json, "usable_crowd_status") ? undefined : json["usable_crowd_status"],
    usableDigitalPrescription: !exists(json, "usable_digital_prescription")
      ? undefined
      : json["usable_digital_prescription"],
    usableDispensingFeature: !exists(json, "usable_dispensing_feature") ? undefined : json["usable_dispensing_feature"],
    usableDispensingType: !exists(json, "usable_dispensing_type") ? undefined : json["usable_dispensing_type"],
    usableExternalAiAssistant: !exists(json, "usable_external_ai_assistant")
      ? undefined
      : json["usable_external_ai_assistant"],
    usableMynaHomeWeb: !exists(json, "usable_myna_home_web") ? undefined : json["usable_myna_home_web"],
    usableOcrPrescription: !exists(json, "usable_ocr_prescription") ? undefined : json["usable_ocr_prescription"],
    usableOnlineCounselingAutoAccepted: !exists(json, "usable_online_counseling_auto_accepted")
      ? undefined
      : json["usable_online_counseling_auto_accepted"],
    usableOnlineMedicationGuidance: !exists(json, "usable_online_medication_guidance")
      ? undefined
      : json["usable_online_medication_guidance"],
    usablePrescriptionInquiry: !exists(json, "usable_prescription_inquiry")
      ? undefined
      : json["usable_prescription_inquiry"],
    usableScanPrescription: !exists(json, "usable_scan_prescription") ? undefined : json["usable_scan_prescription"],
    usableSkipUnluckyNumbers: !exists(json, "usable_skip_unlucky_numbers")
      ? undefined
      : json["usable_skip_unlucky_numbers"],
    usableTouchReception: !exists(json, "usable_touch_reception") ? undefined : json["usable_touch_reception"],
    usableVoiceAnnouncement: !exists(json, "usable_voice_announcement") ? undefined : json["usable_voice_announcement"],
    visibility: json["visibility"],
    wantsEmailNotification: !exists(json, "wants_email_notification") ? undefined : json["wants_email_notification"],
    wantsFaxCounselingRequestedRemind: !exists(json, "wants_fax_counseling_requested_remind")
      ? undefined
      : json["wants_fax_counseling_requested_remind"],
    wantsFaxNotification: !exists(json, "wants_fax_notification") ? undefined : json["wants_fax_notification"],
  };
}

export function PharmacyPharmacyRegistrableToJSON(object?: PharmacyPharmacyRegistrable | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    address: value.address,
    ai_ocr_recognition_mode: value.aiOcrRecognitionMode,
    calendar_type: value.calendarType,
    chain_id: value.chainId,
    closed_days: value.closedDays,
    counseling_booth_count: value.counselingBoothCount,
    counseling_booth_name: value.counselingBoothName,
    counseling_reception_hours: PharmacyPharmacyHoursToJSON(value.counselingReceptionHours),
    counseling_recurring_calendars:
      value.counselingRecurringCalendars === undefined
        ? undefined
        : (value.counselingRecurringCalendars as Array<any>).map(PharmacyRecurringCalendarToJSON),
    counseling_slot_minutes: value.counselingSlotMinutes,
    create_talkroom: value.createTalkroom,
    delivery_setting: PharmacyPharmacyDeliverySettingsToJSON(value.deliverySetting),
    disable_counseling_slot_unspecified: value.disableCounselingSlotUnspecified,
    dispensing_counters: value.dispensingCounters,
    dispensing_reception_hours: PharmacyPharmacyHoursToJSON(value.dispensingReceptionHours),
    dispensing_recurring_calendars:
      value.dispensingRecurringCalendars === undefined
        ? undefined
        : (value.dispensingRecurringCalendars as Array<any>).map(PharmacyRecurringCalendarToJSON),
    email: value.email,
    external_ai_assistant_scope:
      value.externalAiAssistantScope === undefined
        ? undefined
        : (value.externalAiAssistantScope as Array<any>).map(PharmacyExternalAIAssistantScopeToJSON),
    external_id: value.externalId,
    fax: value.fax,
    fax_prescription_with_image: value.faxPrescriptionWithImage,
    group_id: value.groupId,
    has_line_official_account: value.hasLineOfficialAccount,
    ignore_public_holiday: value.ignorePublicHoliday,
    institution_code: value.institutionCode,
    is_counseling_reception_until_closing: value.isCounselingReceptionUntilClosing,
    is_dispensing: value.isDispensing,
    is_display_visit_within_one_hour: value.isDisplayVisitWithinOneHour,
    is_mobile_order_qr_code_enlarged: value.isMobileOrderQrCodeEnlarged,
    is_online: value.isOnline,
    is_online_payment: value.isOnlinePayment,
    is_parking: value.isParking,
    is_prescription: value.isPrescription,
    is_same_day_delivery: value.isSameDayDelivery,
    is_screening: value.isScreening,
    is_tell: value.isTell,
    latitude: (value.latitude as unknown as string) == "" ? undefined : value.latitude,
    line_interview_url: value.lineInterviewUrl,
    longitude: (value.longitude as unknown as string) == "" ? undefined : value.longitude,
    merit_tag: PharmacyMeritTagsToJSON(value.meritTag),
    min_integrated_counseling_interval_minutes: value.minIntegratedCounselingIntervalMinutes,
    mobile_order_calling_screen_messages:
      value.mobileOrderCallingScreenMessages === undefined
        ? undefined
        : (value.mobileOrderCallingScreenMessages as Array<any>).map(PharmacyMobileOrderCallingScreenMessageToJSON),
    myna_home_web_url: value.mynaHomeWebUrl,
    name: value.name,
    nearest_station: PharmacyPharmacyStationsToJSON(value.nearestStation),
    note: value.note,
    online_payment_method: PharmacyPaymentMethodToJSON(value.onlinePaymentMethod),
    own_interview_url: value.ownInterviewUrl,
    payment_method: PharmacyPaymentMethodToJSON(value.paymentMethod),
    postal_code: value.postalCode,
    prescription_reading_mode: value.prescriptionReadingMode,
    printer_ip: value.printerIp,
    printer_paper_type: value.printerPaperType,
    printer_type: value.printerType,
    recommendation: value.recommendation,
    second_external_id: value.secondExternalId,
    send_follow_up_message: value.sendFollowUpMessage,
    talkroom_expire_days: value.talkroomExpireDays,
    tel: value.tel,
    tokushoho: PharmacyTokushohoToJSON(value.tokushoho),
    usable_accept_code: value.usableAcceptCode,
    usable_aiocr: value.usableAiocr,
    usable_counseling_booth_voice_announcement: value.usableCounselingBoothVoiceAnnouncement,
    usable_counseling_slot_quota: value.usableCounselingSlotQuota,
    usable_crowd_status: value.usableCrowdStatus,
    usable_digital_prescription: value.usableDigitalPrescription,
    usable_dispensing_feature: value.usableDispensingFeature,
    usable_dispensing_type: value.usableDispensingType,
    usable_external_ai_assistant: value.usableExternalAiAssistant,
    usable_myna_home_web: value.usableMynaHomeWeb,
    usable_ocr_prescription: value.usableOcrPrescription,
    usable_online_counseling_auto_accepted: value.usableOnlineCounselingAutoAccepted,
    usable_online_medication_guidance: value.usableOnlineMedicationGuidance,
    usable_prescription_inquiry: value.usablePrescriptionInquiry,
    usable_scan_prescription: value.usableScanPrescription,
    usable_skip_unlucky_numbers: value.usableSkipUnluckyNumbers,
    usable_touch_reception: value.usableTouchReception,
    usable_voice_announcement: value.usableVoiceAnnouncement,
    visibility: value.visibility,
    wants_email_notification: value.wantsEmailNotification,
    wants_fax_counseling_requested_remind: value.wantsFaxCounselingRequestedRemind,
    wants_fax_notification: value.wantsFaxNotification,
  };
}
